import { render, staticRenderFns } from "./HostsAdd.vue?vue&type=template&id=48187c5e&"
import script from "./HostsAdd.vue?vue&type=script&lang=js&"
export * from "./HostsAdd.vue?vue&type=script&lang=js&"
import style0 from "./HostsAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports